const {removeCommas} = require("@persian-tools/persian-tools");
const {isEmpty} = require("lodash");

module.exports.selectToData = (data, isMulti = false) => {
    if (isMulti) {
        let out = "";
        if (!isEmpty(data)) {
            data.map((item, index) => {
                out += item.value + ((index != (data.length - 1)) ? "," : "");
            });
        }
        return out;

    } else {
        return data.value;
    }

}

module.exports.validateNumber = (value) => {
    const matches = value.match(
        /^(?:0\.(?:0[0-9]|[0-9]\d?)|[0-9]\d*(?:\.\d{1,2})?)(?:e[+-]?\d+)?$/
    );
    return matches?.length > 0 || "Not a Number";
};


function replaceNonNumericCharacters(str) {
    return str.replace(/\D/g, '');
}

module.exports.onlyNumber = (value, isCommas = false) => {
    if (isNaN(removeCommas(value))) return replaceNonNumericCharacters(value);
    if (value != "") {
        return (isCommas) ? removeCommas(value) : value;
    }
    return value;
}





